import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHomeRoutingModule } from './page-home-routing.module';
import { KtdGridModule } from '@katoid/angular-grid-layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModalEditarComponent } from './components/caja-valor/modal-editar/modal-editar.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [ModalEditarComponent],
  imports: [
    CommonModule,
    PageHomeRoutingModule,
    KtdGridModule,
    DragDropModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    FormsModule,
    InputTextModule,
  ],
  exports: [],
})
export class PageHomeModule {}
